import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class WM2000TempNode extends BaseNode {
    constructor() {
        super();
        this.name = 'WM2000 Temp Sensor';
        this.id = 'node_wm2000ev_temp';
        this.linkedFeature = 'wm2000ev_temp';
        this.inputs = [
            {
                name: 'Read Sensor',
                portId: 'wm2000ev_read',
                params: [],
            },
        ];
        this.outputs = [
            {
                name: 'Data Available',
                portId: 'wm2000ev_data',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.FLOAT,
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        let dataLocation = '';

        let links = project.getNodeLinks(this, 'wm2000ev_data');
        if (links.length > 0) {
            const link = links[0];
            dataLocation += `'****${link.getSourceId()}****'\r\n`;
        }

        links = project.getNodeLinks(this, 'wm2000ev_read');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];

            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                template: `
    EV_TEMP_read(tbt29_get_c(EV_TEMP_CHANNEL_NUM))`,
            });
        }

        blocks.push({
            location: 'DEVICE_TBS',
            id: 'EV_TEMP_read',
            blockType: BlockType.LOCATION,
            template: `
sub EV_TEMP_read(data as float)
    ${dataLocation}
end sub
        `,
        });
        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            id: 'declare_EV_TEMP_read',
            blockType: BlockType.CODE,
            template: `
declare sub EV_TEMP_read(data as float)`,
        });


        // for (let i = 0; i < links.length; i += 1) {
        //     const link = links[i];
        //     blocks.push({
        //         location: 'on_sys_timer',
        //         blockType: BlockType.CODE,
        //         template: `'****${link.getID()}****'`,
        //     });
        // }

        return blocks;
    }
}
